/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAyVjBIMTFWMkg1VjBINFYySDBWMTZIMTZWMkgxMlpNMTUgMTVIMVY2SDE1VjE1Wk0xIDVWM0gxNVY1SDFaIiBmaWxsPSJpbmhlcml0Ii8+";